import { RootState } from 'features/rootReducer';

export const selectMemberCloset = (state: RootState) => state.memberCloset.memberCloset;
export const selectMemberClosetLoading = (state: RootState) => state.memberCloset.loading;
export const selectMemberClosetError = (state: RootState) => state.memberCloset.error;
